module.exports = require('@loadable/component');
